import React from "react";

export const DocIcon = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 800"
    >
      <defs></defs>
      <circle className="cls-1" cx="399.63" cy="400.43" r="386.5" />
      <path
        className="cls-2"
        d="M256.09,594.51H493.76V268.88H256.09ZM338,299H462.34v31.32H338Zm-50.14,77.46H462.24v31.32H287.81Zm0,77.45H462.24v31.33H287.81Zm0,77.46H462.24v31.32H287.81Z"
      />
      <polygon
        className="cls-2"
        points="323.04 203.83 323.04 237.46 525.69 237.46 525.69 529.47 560.71 529.47 560.71 203.83 323.04 203.83"
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitTraining/components/TTTElement/icons/DocIcon.js